import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-migration/lib";

import { useLoadLetterBatches } from "../../hooks/useLoadLetterBatches";
import { Filters } from "./Filters";
import { LetterBatchesFilterFormProvider } from "./Filters/LetterBatchesFilterFormProvider";
import { LetterBatchesFilterFormData } from "./Filters/LetterBatchesFilterSchema";
import { LetterBatchesTable } from "./LetterBatchesTable";

export const LetterBatchesContent = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext<LetterBatchesFilterFormData>();

  const { loading, letterBatches, totalCount } = useLoadLetterBatches({
    name: watch("search"),
    fromDate: watch("startDate")?.toISOString(),
    toDate: watch("endDate")?.toISOString(),
  });

  return (
    <div className="atlas-flex atlas-flex-col atlas-w-full" data-testid="letter-batches">
      <div className="atlas-flex atlas-w-full atlas-border-b atlas-border-border-divider-subtle">
        <span className="atlas-text-xl atlas-font-normal atlas-leading-8 atlas-py-4 atlas-px-5">
          {t("sites.letter_batches.letters")}
        </span>
      </div>
      <div className="atlas-border-b atlas-border-border-divider-subtle">
        <Filters shownCount={letterBatches.length} totalCount={totalCount} />
      </div>
      <div className="atlas-min-h-0">
        <LetterBatchesTable loading={loading} data={letterBatches} />
      </div>
    </div>
  );
};

export const LetterBatches = () => {
  return (
    <LetterBatchesFilterFormProvider>
      <LetterBatchesContent />
    </LetterBatchesFilterFormProvider>
  );
};
